import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AuthScreen } from "@h2j-data-team/ui";

import { authClient } from "@/lib/auth-client";
import { BrandLogo } from "@/components/brand-logo";
import { PRODUCT_NAME } from "@repo/shared";
import { APP_VERSION } from "@/lib/version";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async () => {
    const session = await authClient.getSession();

    // If already authenticated, redirect to main app
    if (session.data) {
      throw redirect({ to: "/connections", search: { q: undefined } });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const { t } = useTranslation("auth");

  return (
    <AuthScreen
      logo={<BrandLogo className="h-8 w-auto" />}
      panelLogo={<BrandLogo onDark className="h-7 w-auto" />}
      headline={t("authLayout.tagline")}
      description={t("authLayout.subtitle")}
      footer={`© ${new Date().getFullYear()} ${PRODUCT_NAME} · v${APP_VERSION}`}
    >
      <Outlet />
    </AuthScreen>
  );
}
